import React from 'react'
import { rhythm } from '../../utils/typography'
import profilePic from './juha.jpg'

class Bio extends React.Component {
  render () {
    return (
      <p
        style={{
          marginBottom: rhythm(2.5),
        }}
      >
        <img
          src={profilePic}
          alt={`author ${this.props.data.site.siteMetadata.authorName}`}
          style={{
            float: 'left',
            marginRight: rhythm(1/4),
            marginBottom: 0,
            width: rhythm(2),
            height: rhythm(2),
            borderRadius: 40,
          }}
        />
        Home of <a href="http://juha.net">{this.props.data.site.siteMetadata.authorName}</a> who lives and works in Helsinki area building useful things. Follow & contact me via <a href="https://twitter.com/JuhaNet">Twitter</a>, <a href="https://www.instagram.com/jubilem/">Instagram</a> or <a href="https://www.linkedin.com/in/jubilem/">LinkedIn</a>.
      </p>
    )
  }
}

export default Bio



// WEBPACK FOOTER //
// ./src/components/Bio/index.js